import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0cd9dfae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row gy-5 g-xl-8" }
const _hoisted_2 = { class: "col-xxl-4" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "row gx-5 gx-xl-8 mb-5 mb-xl-8" }
const _hoisted_5 = { class: "col-xl-3 mb-2" }
const _hoisted_6 = {
  class: "card h-150px bgi-no-repeat bgi-size-cover card-xl-stretch",
  style: {"background-image":"url('media/patterns/feess.png')"}
}
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "col-xl-5 mb-2" }
const _hoisted_9 = {
  class: "card h-150px bgi-no-repeat bgi-size-cover card-xl-stretch",
  style: {"background-image":"url('media/patterns/bulletin.png')","background-position-x":"center"}
}
const _hoisted_10 = { class: "card-body d-flex align-items-center justify-content-between flex-wrap" }
const _hoisted_11 = { class: "fw-normal" }
const _hoisted_12 = { class: "annuelle fs-7" }
const _hoisted_13 = { class: "col-xl-4 mb-2" }
const _hoisted_14 = { class: "row mb-2" }
const _hoisted_15 = {
  class: "card bgi-no-repeat bgi-size-cover card-xl-stretch",
  style: {"background-image":"url('media/patterns/bulletin.png')","height":"70px"}
}
const _hoisted_16 = {
  class: "m-5",
  style: {"font-size":"15px"}
}
const _hoisted_17 = { class: "fw-normal" }
const _hoisted_18 = { class: "annuelle fs-7" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = {
  class: "card bgi-no-repeat bgi-size-cover card-xl-stretch",
  style: {"background-image":"url('media/patterns/bulletin.png')","height":"70px"}
}
const _hoisted_21 = {
  class: "m-5",
  style: {"font-size":"15px"}
}
const _hoisted_22 = { class: "fw-normal" }
const _hoisted_23 = { class: "annuelle fs-7" }
const _hoisted_24 = { class: "row gx-5 gx-xl-8 mb-5 mb-xl-8" }
const _hoisted_25 = { class: "col-xl-6" }
const _hoisted_26 = {
  class: "card h-150px bgi-no-repeat bgi-size-cover card-xl-stretch",
  style: {"background-image":"url('media/patterns/schedule.png')"}
}
const _hoisted_27 = { class: "card-body d-flex flex-column justify-content-between" }
const _hoisted_28 = {
  class: "text-black-800 text-hover-primary fs-2",
  style: {"padding-top":"5.25rem !important"}
}
const _hoisted_29 = { class: "row gx-5 gx-xl-8 pt-5" }
const _hoisted_30 = { class: "col-xxl-6 mb-2" }
const _hoisted_31 = {
  class: "card h-150px bgi-no-repeat bgi-size-cover card-xl-stretch",
  style: {"background-image":"url('media/patterns/homework.jpg')"}
}
const _hoisted_32 = { class: "card-body content" }
const _hoisted_33 = { class: "end" }
const _hoisted_34 = { class: "col-xxl-6 mb-2" }
const _hoisted_35 = {
  class: "card h-150px bgi-no-repeat bgi-size-cover card-xl-stretch content",
  style: {"background-color":"#f1416c","background-image":"url('media/patterns/vector-1.png')"}
}
const _hoisted_36 = { class: "fw-bold text-white text-center fs-2" }
const _hoisted_37 = { class: "col-xl-6 mb-2" }
const _hoisted_38 = {
  class: "card h-100 bgi-no-repeat bgi-size-cover card-xl-stretch mb-5 mb-xl-8",
  style: {"background-image":"url('media/patterns/canteenn.png')"}
}
const _hoisted_39 = { class: "card-body d-flex flex-column justify-content-between" }
const _hoisted_40 = { class: "text-white fw-bolder fs-3" }
const _hoisted_41 = { class: "text-white mb-2" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_prodileCard = _resolveComponent("prodileCard")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_prodileCard, {
        "widget-classes": "card-xl-stretch mb-xl-8",
        "widget-color": "white",
        "chart-height": "200",
        "stroke-color": "#cb1e46"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/paiement",
            class: "text-primary-inverse-800 text-hover-info fw-bolder fs-2",
            style: {"color":"#20273a"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.t("dashboard.payment")), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_link, {
            to: "/bulletin",
            class: "text-primary-inverse-800 text-hover-secondary fw-bolder fs-2",
            style: {"color":"white"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(_ctx.t("dashboard.report")) + " ", 1),
                    _createElementVNode("p", _hoisted_11, [
                      _createVNode(_component_router_link, { to: "/bulletin/annuelle" }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.t("dashboard.bulletinAnnuelle")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_router_link, {
              to: "/bulletinPilote",
              class: "text-primary-inverse-800 text-hover-secondary fw-bolder fs-2",
              style: {"color":"white"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createTextVNode(_toDisplayString(_ctx.t("dashboard.reportSpec")) + " ", 1),
                    _createElementVNode("p", _hoisted_17, [
                      _createVNode(_component_router_link, { to: "/bulletinPilote/annuelle" }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_18, _toDisplayString(_ctx.t("dashboard.bulletinAnnuelle")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_router_link, {
              to: "/bulletinSpecific",
              class: "text-primary-inverse-800 text-hover-secondary fw-bolder fs-2",
              style: {"color":"white"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createTextVNode(_toDisplayString(_ctx.t("dashboard.reportVerySpec")) + " ", 1),
                    _createElementVNode("p", _hoisted_22, [
                      _createVNode(_component_router_link, { to: "/bulletinSpecific/annuelle" }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_23, _toDisplayString(_ctx.t("dashboard.bulletinAnnuelle")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_router_link, { to: "/emplois" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("h2", _hoisted_28, _toDisplayString(_ctx.t("dashboard.schedule")), 1)
                ])
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_router_link, {
                to: "/devoirs",
                class: "text-primary-inverse-800 text-hover-secondary fw-bolder fs-2",
                style: {"color":"white"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.t("dashboard.homeworks")), 1)
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_router_link, { to: "/avertissement" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.t("dashboard.avertissements")), 1)
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createVNode(_component_router_link, { to: "/cantine" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("h2", _hoisted_41, [
                      _hoisted_42,
                      _createTextVNode(_toDisplayString(_ctx.t("dashboard.canteen")), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}